import $ from 'jquery'

export class Tracking {
  constructor() {
    this.expr = /^(data-dl-).+/
    this.trackingParams = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'gclid',
      'fbclid',
      'li_fat_id',
      'msclkid',
      'ttclid'
    ]
    this.track($('body'))
    this.trackingCookie()
  }

  track($parent) {
    this.handleLinks($parent, '[data-dl]')
  }

  /**
   * Generate or update a tracking cookie named "btrack" with URL params.
   * Supported params: utm_source, utm_medium, utm_campaign, utm_term,
   * utm_content, gclid, fbclid, li_fat_id, msclkid, ttclid.
   */
  trackingCookie() {
    const urlParams = new URLSearchParams(window.location.search)
    const trackingData = {}

    // Extract tracking params from URL
    this.trackingParams.forEach((param) => {
      const value = urlParams.get(param)
      if (value) {
        trackingData[param] = value
      }
    })

    // Get Matomo visitor ID from cookie (pattern: _pk_id.{site_id}.{random})
    const matomoCookie = this.getMatomoCookie()
    if (matomoCookie) {
      trackingData.pkvid = matomoCookie
    }

    // If no tracking params found, do nothing
    if (Object.keys(trackingData).length === 0) {
      return
    }

    // Merge with existing cookie data if present
    const existingCookie = this.getCookie('btrack')
    const existingData = existingCookie ? JSON.parse(existingCookie) : {}
    const mergedData = { ...existingData, ...trackingData }

    // Set cookie (expires in 90 days, path /, domain root)
    const expirationDate = new Date()
    expirationDate.setTime(expirationDate.getTime() + 90 * 24 * 60 * 60 * 1000)
    const expires = 'expires=' + expirationDate.toUTCString()
    const cookieString = 'btrack=' + encodeURIComponent(JSON.stringify(mergedData))
      + '; ' + expires + '; path=/; SameSite=Lax'

    document.cookie = cookieString
  }

  /**
   * Get a cookie value by name.
   *
   * @param {string} name Cookie name.
   * @returns {string|null} Cookie value or null if not found.
   */
  getCookie(name) {
    const nameEQ = name + '='
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim()
      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length))
      }
    }
    return null
  }

  /**
   * Get Matomo visitor ID from cookie.
   * Looks for cookies matching pattern: _pk_id.{site_id}.{random}
   * Example: _pk_id.f6975405-346a-42d3-a5b9-eda7fbe1cad0.4425
   *
   * @returns {string|null} Matomo visitor ID (first part of cookie value) or null if not found.
   */
  getMatomoCookie() {
    const cookies = document.cookie.split(';')

    // Find cookie starting with _pk_id.
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()

      if (cookie.startsWith('_pk_id.f6975405-346a-42d3-a5b9-eda7fbe1cad0')) {
        // Extract cookie value (after the = sign)
        const equalIndex = cookie.indexOf('=')
        if (equalIndex === -1) continue

        const cookieValue = cookie.substring(equalIndex + 1)

        // Matomo cookie value format: visitorId.timestamp.visitCount.currentTimestamp.lastVisitTimestamp
        // We want the visitor ID (first part before the first dot)
        const parts = cookieValue.split('.')
        if (parts.length > 0 && parts[0]) {
          return decodeURIComponent(parts[0])
        }
      }
    }

    return null
  }

  handleLinks($parent, $selector) {
    $parent.on('click', $selector, (event) => {
      const element = event.currentTarget
      const vars = {}
      const dataAttributes = element.attributes

      // Test all the attributes
      for (let i = 0; i < dataAttributes.length; i++) {
        const name = dataAttributes[i].nodeName
        const value = dataAttributes[i].nodeValue

        if (this.expr.test(name)) {
          if (name === "data-dl-link-url") {
            if (value) {
              vars["link-url"] = value
            } else {
              vars["link-url"] = element.href
            }
          } else if (name === "data-dl-link-text") {
            if (value) {
              vars["link-text"] = value
            } else {
              vars["link-text"] = element.innerText
            }
          } else {
            const nameClean = name.replace(/data-dl-/g, '')
            vars[nameClean] = value
          }
        }
      }
      this.addDataToLayer(vars)
    })
  }

  // Optimisation
  addDataToLayer(vars) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(vars)
  }
}
